import { render, staticRenderFns } from "./PresetsRaces.vue?vue&type=template&id=9cdb3a16&scoped=true"
import script from "./PresetsRaces.vue?vue&type=script&lang=js"
export * from "./PresetsRaces.vue?vue&type=script&lang=js"
import style0 from "./PresetsRaces.vue?vue&type=style&index=0&id=9cdb3a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdb3a16",
  null
  
)

export default component.exports